export default __webpack_public_path__ + "static/media/zombieBg.93bf4320.png";